import axios from 'axios';
import React, { Component, useState } from 'react';
import './Footer.css';
const BASE_URL = 'https://testwire.wockhardt.com';
//const Wockhardt_URL = 'http://example.com/some-page';
const Wockhardt_URL = 'https://e2api.wockhardt.com/api/Flutter/PostEmpDetails'
const jwt = localStorage.getItem('jwt');

const handleLogout = () => {
    localStorage.removeItem('jwt');
    window.location.href = '/login';
  }

class ApprovalNotifications extends React.Component 
{
  state = {showDiv: false,udata:null, data1: null,data2:null,responseData: null,username: '',email: '',job: '',picture: '',pictureurl: '',education:'',previousemployment:'',address:'',pan:'',aadhar:'',uan:'',contactno:'',designation:'',empcode:'',Gender:'',dob:'',positioN_CODE:'',position:'',area:'',subarea:'',subgroup:'',doj:'',companY_CODE:'',cosT_CENTER:'',worK_CNTRCT:'',organization:'',communication:'',flM_CODE:'',reP_MGR:'',peR_ADMIN:'',paY_ADMIN:'',orG_CODE:'',salutation:'',firstName:'',lastName:'',middleName:'',aadharName:'',officialEmail:'',personalMobile:'',bankName:'',bankAccountNo:'',ifsc:'',pfNo:'',passportNo:'',personalEmail:'',officeTelNo:'',officeMobile:'',country:'',jobrole:''};

  fetchData0 = (userId) => 
  {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{headers: {Authorization: `Bearer ${jwt}`,'Content-Type': 'application/json'},})
    .then(res => {this.setState({ data0: res.data });console.log('API response user', res);})
    .catch(error => {console.error('API ERROR:', error);});
  };

  fetchData1 = () => {
    axios.get(`${BASE_URL}/api/header-buttons?populate=*`,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        this.setState({ data1: res.data });
        console.log('API response for headrr:', res);

      })
      .catch(error => {
        console.error('API error for header-button:', error);
      });
  };

  fetchUserData = (userId) => {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        console.log(`API response for user data with id ${userId}:`, res);
        this.setState({ responseData: res.data });
        let username = res.data.username;
        let email = res.data.email;
        let job = res.data.job;
        let education = res.data.education;
        let previousemployment = res.data.previousemployment;
        let address = res.data.address;
        let pan = res.data.pan;
        let aadhar = res.data.aadhar;
        let uan = res.data.uan;
        let contactno = res.data.contactno;
        let designation = res.data.designation;
        let empcode = res.data.empcode;
        let Gender = res.data.Gender;
        let dob = res.data.dob;
        let picture = res.data.picture.name;
        let pictureurl = res.data.picture.url;
        let positioN_CODE = res.data.positioN_CODE;
        let position = res.data.position;
        let area = res.data.area;
        let subarea = res.data.subarea;
        let subgroup = res.data.subgroup;
        let doj = res.data.doj;
        let companY_CODE = res.data.companY_CODE;
        let cosT_CENTER = res.data.cosT_CENTER;
        let worK_CNTRCT = res.data.worK_CNTRCT;
        let organization = res.data.organization;
        let communication = res.data.communication;
        let flM_CODE = res.data.flM_CODE;
        let reP_MGR = res.data.reP_MGR;
        let peR_ADMIN = res.data.peR_ADMIN;
        let paY_ADMIN = res.data.paY_ADMIN;
        let orG_CODE = res.data.orG_CODE;
        let country = res.data.country;
        let jobrole = res.data.jobrole;
        let salutation = res.data.salutation;
        let lastName = res.data.lastName;
        let firstName = res.data.firstName;
        let middleName = res.data.middleName;
        let officialEmail = res.data.officialEmail;
        let personalMobile = res.data.personalMobile;
        let bankName = res.data.bankName;
        let bankAccountNo = res.data.bankAccountNo;
        let ifsc = res.data.ifsc;
        let aadharName = res.data.aadharName;
        let pfNo = res.data.pfNo;
        let passportNo = res.data.passportNo;
        let personalEmail = res.data.personalEmail;
        let officeTelNo = res.data.officeTelNo;
        let officeMobile = res.data.officeMobile;
        this.setState({ username });
        this.setState({ email });
        this.setState({ job });
        this.setState({ picture });
        this.setState({ pictureurl });
        this.setState({ education });
        this.setState({ previousemployment });
        this.setState({ address });
        this.setState({ pan });
        this.setState({ aadhar });
        this.setState({ uan });
        this.setState({ contactno });
        this.setState({ designation });
        this.setState({ empcode });
        this.setState({ Gender });
        this.setState({ dob });
        this.setState({ positioN_CODE });
        this.setState({ position });
        this.setState({ area });
        this.setState({ subarea });
        this.setState({ subgroup });
        this.setState({ doj });
        this.setState({ companY_CODE });
        this.setState({ cosT_CENTER });
        this.setState({ worK_CNTRCT });
        this.setState({ organization });
        this.setState({ communication });
        this.setState({ flM_CODE });
        this.setState({ reP_MGR });
        this.setState({ peR_ADMIN });
        this.setState({ paY_ADMIN });
        this.setState({ orG_CODE });
        this.setState({ country });
        this.setState({ jobrole });
        this.setState({ salutation });
        this.setState({ lastName });
        this.setState({ firstName });
        this.setState({ middleName });
        this.setState({ officialEmail });
        this.setState({ personalMobile });
        this.setState({ bankName });
        this.setState({ bankAccountNo });
        this.setState({ ifsc });
        this.setState({ aadharName });
        this.setState({ pfNo });
        this.setState({ passportNo });
        this.setState({ personalEmail });
        this.setState({ officeTelNo });
        this.setState({ officeMobile });
      })
      .catch(error => {
        console.error(`API error for user data with id ${userId}:`, error);
      });
  };

  fetchUData1 = () => {
    axios.get(`${BASE_URL}/api/users?populate=*`)
      .then(res => {
        console.log('API response for user data:', res);
        const filteredData = res.data.filter(user => user.profileapproved === "false");
        {/* 
        const sortedData = filteredData.sort((a,b)=> new Date(b.updated_at)-new Date(a.updated_at));
        const latestData = sortedData.length > 0 ? [sortedData[0]]  : []; 
        this.setState({ udata: latestData });
        console.log('profileapprovedd value:', latestData);
         */}
        this.setState({ udata: filteredData });
        console.log('profileapprovedd value:', filteredData);
      })
      .catch(error => {
        console.error('API error for user data:', error);
      });
  };

  /*fetchusercount = () => {
    const updatedAfter = // Set a date or timestamp for when user profiles were last updated
    axios.get(`${BASE_URL}/api/users?populate=*&updated_at_gt=${updatedAfter}`)
      .then(res => {
        console.log('API response for user data:', res);
        this.setState({ ucount: res.data });
      })
      .catch(error => {
        console.error('API error for user data:', error);
      });
  };*/




  componentDidMount() {
    this.fetchData1();
    this.fetchUData1();
    //this.fetchusercount();
    let responseData = localStorage.getItem("responseData");
    this.setState({ responseData });
    {/* 
    axios.get(`${BASE_URL}/api/users/{$id}`)
      .then(res => {
        console.log('API response for user data:', res);
        const userData=res.data;
        const updatedFields={};
        if (userData.username != userData.username)
        {
          updatedDields.username = userData.username;
        }
       if (userData.email != userData.email)
       {
         updatedFields.email = userData.email;
       }
       if (userData.empcode != userData.empcode)
       {
         updatedFields.empcode = userData.empcode;
       }
       if (Object.keys(updatedFields).length > 0)
       {
         this.setState(updatedFields);
       }
      )
      .catch(error => {
        console.error('API error for user data:', error);
      });
     */}
    let jwtDataParsed = JSON.parse(responseData);
    let id = jwtDataParsed.user.id;
    let username = jwtDataParsed.user.username;
    let email = jwtDataParsed.user.email;
    let job = jwtDataParsed.user.job;
    let education = jwtDataParsed.user.education;
    let previousemployment = jwtDataParsed.user.previousemployment;
    let address = jwtDataParsed.user.address;
    let pan = jwtDataParsed.user.pan;
    let aadhar = jwtDataParsed.user.aadhar;
    let uan = jwtDataParsed.user.uan;
    let contactno = jwtDataParsed.user.contactno;
    let designation = jwtDataParsed.user.designation;
    let empcode = jwtDataParsed.user.empcode;
    let Gender = jwtDataParsed.user.Gender;
    let dob = jwtDataParsed.user.dob;
    let positioN_CODE = jwtDataParsed.user.positioN_CODE;
    let position = jwtDataParsed.user.position;
    let area = jwtDataParsed.user.area;
    let subarea = jwtDataParsed.user.subarea;
    let subgroup = jwtDataParsed.user.subgroup;
    let doj = jwtDataParsed.user.doj;
    let companY_CODE = jwtDataParsed.user.companY_CODE;
    let cosT_CENTER = jwtDataParsed.user.cosT_CENTER;
    let worK_CNTRCT = jwtDataParsed.user.worK_CNTRCT;
    let organization = jwtDataParsed.user.organization;
    let communication = jwtDataParsed.user.communication;
    let flM_CODE = jwtDataParsed.user.flM_CODE;
    let reP_MGR = jwtDataParsed.user.reP_MGR;
    let peR_ADMIN = jwtDataParsed.user.peR_ADMIN;
    let paY_ADMIN = jwtDataParsed.user.paY_ADMIN;
    let orG_CODE = jwtDataParsed.user.orG_CODE;
    let country = jwtDataParsed.user.country;
    let jobrole = jwtDataParsed.user.jobrole;
    let salutation = jwtDataParsed.user.salutation;
        let lastName = jwtDataParsed.user.lastName;
        let firstName = jwtDataParsed.user.firstName;
        let middleName = jwtDataParsed.user.middleName;
        let officialEmail = jwtDataParsed.user.officialEmail;
        let personalMobile = jwtDataParsed.user.personalMobile;
        let bankName = jwtDataParsed.user.bankName;
        let bankAccountNo = jwtDataParsed.user.bankAccountNo;
        let ifsc = jwtDataParsed.user.ifsc;
        let aadharName = jwtDataParsed.user.aadharName;
        let pfNo = jwtDataParsed.user.pfNo;
        let passportNo = jwtDataParsed.user.passportNo;
        let personalEmail = jwtDataParsed.user.personalEmail;
        let officeTelNo = jwtDataParsed.user.officeTelNo;
        let officeMobile = jwtDataParsed.user.officeMobile;
    this.setState({ username });
    this.setState({ email });
    this.setState({ job });
    this.setState({ education });
    this.setState({ previousemployment });
    this.setState({ address });
    this.setState({ pan });
    this.setState({ aadhar });
    this.setState({ uan });
    this.setState({ contactno });
    this.setState({ designation });
    this.setState({ empcode });
    this.setState({ Gender });
    this.setState({ dob });
    this.setState({ id });
    if (id) {
      this.fetchData0(id);
    } else {
      console.error('id is undefined');
    }
    this.fetchUserData(id);
    this.setState({ positioN_CODE });
    this.setState({ position });
    this.setState({ area });
    this.setState({ subarea });
    this.setState({ subgroup });
    this.setState({ doj });
    this.setState({ companY_CODE });
    this.setState({ cosT_CENTER });
    this.setState({ worK_CNTRCT });
    this.setState({ organization });
    this.setState({ communication });
    this.setState({ flM_CODE });
    this.setState({ reP_MGR });
    this.setState({ peR_ADMIN });
    this.setState({ paY_ADMIN });
    this.setState({ orG_CODE});
    this.setState({ country});
    this.setState({ jobrole});
    this.setState({ salutation });
        this.setState({ lastName });
        this.setState({ firstName });
        this.setState({ middleName });
        this.setState({ officialEmail });
        this.setState({ personalMobile });
        this.setState({ bankName });
        this.setState({ bankAccountNo });
        this.setState({ ifsc });
        this.setState({ aadharName });
        this.setState({ pfNo });
        this.setState({ passportNo });
        this.setState({ personalEmail });
        this.setState({ officeTelNo });
        this.setState({ officeMobile });
  }

  handleClick = () => {
    this.setState({
      showDiv: !this.state.showDiv
    });
  };

  handleGenerateQR = () => {
    const { userId} = this.state.data0;
console.log('Test')
    const payload = {data: this.state.data0};
	  console.log(JSON.stringify(payload));;
console.log('QR Data');
	  console.log(payload);
    axios.post('https://vcqr.wockhardt.com/api/v1/dostemp', payload,{
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json',
     
  },})
      .then(response => {
        //console.log('QR generation response:', response);
        alert('Your request for eVisiting Card has been sent to Functional Head for Approval.');
      })
      .catch(error => {
        console.error('QR generation error:', error);
      });
  };

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  /*handleApprove = (empcode) => {
    const user = this.state.udata.find(item => item.empcode === empcode);
    if (!user) {
      console.error(`User with empcode ${empcode} not found`);
      return;
    }
    fetch(`${Wockhardt_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(user)
    })
    .then(response => {
      if (response.ok) {
        console.log('Data sent successfully');
        console.log(JSON.stringify(user)); // Log the user data that was sent
      } else {
        console.error('Error sending data');
        console.log(JSON.stringify(user));
      }
    })
    .catch(error => {
      console.error('Error sending data', error);
      console.log(JSON.stringify(user));
    });
  }; Working Code */

  handleApprove = (empcode) => {
    var user = this.state.udata.find(item => item.empcode === empcode);
    user.confirmed = 1;
    user.blocked = 0;
    //user.profileapproved = 1;
    //above added true 1 and false 0 - 10 April 2024 by client discussion
    console.log('User ID:', user);
    if (!user) {
      console.error(`User with empcode ${empcode} not found`);
      return;
    }
  
    console.log('User data:', user);
    axios.put(`${BASE_URL}/api/users/${user.id}`, { profileapproved: true.toString() })
      .then(res => {
        console.log('User data updated:', res);
        
      })
      .catch(error => {
        console.error('API error updating user data:', error);
      });
  
      fetch(`${Wockhardt_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(user)
    })
    .then(response => {
      if (response.ok) {
        console.log('Data sent successfully');
        console.log(JSON.stringify(user));
        window.location.reload();
      } else {
        console.error('Error sending data');
        console.log(JSON.stringify(user));
      }
    })
    .catch(error => {
      console.error('Error sending data', error);
      console.log(JSON.stringify(user));
    });
  };
  
  
  render() {
    //const updatedProfilesCount = this.state.ucount.length;
    if (this.state.udata === null ||this.state.data1 === null || this.state.responseData === null) 
    {
      return <div>Loading...</div>;
    }
    return (
        <div className='bg-silver1'>
            <div className='bg-white fixed top-0 right-0 left-0 z-20 '>
                <div className="flex justify-between mb-2" > 
                    <div className='mt-3 ml-5'>
                        <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
                    </div>
                    <div className='flex'>
                        <ul class="navbar-list">
                     <li>
                  <img style={{marginTop:5, marginRight:5,cursor:'pointer', borderWidth:2, borderColor:'#0f90c0'}} src={this.state.pictureurl ? `${BASE_URL}${this.state.pictureurl}` : 'https://testwire.wockhardt.com/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z'} alt={this.state.picture.alternativeText}  class="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white"  onClick={this.handleClick} />
                        {this.state.showDiv && (<div class="iq-sub-dropdown iq-user-dropdown" style={{width:'auto',right:'0', position:'absolute', background:'#ffffff', padding:0, borderRadius:'4px', boxShadow:'0px 0px 25px 0px rgba(45, 69, 95, 0.1)'}}>
                           <div class="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                              <div class="iq-card-body p-0 " style={{padding:0}}>
                                 <div class="bg-primary p-3" style={{background:'#0f90c0'}}>
                                  <h5 class="mb-0 text-white text-xs line-height">Welcome, {this.state.username} </h5>
                                  <span class="text-white text-xs">{this.state.email}</span>
                                  <p class="text-white text-xs">{this.state.empcode}</p>
                                 </div>
                                 <a href="/profile" class="iq-sub-card iq-bg-primary-hover" style={{fontSize:'inherit', padding:5, lineHeight:'normal', borderBottom:'1px solid #0f90c0', display:'inline-block', width:'100%'}}>
                                    <div class="media align-items-center">
                                       <div class="media-body ml-3" style={{marginLeft:'1rem'}}>
                                          <h6 class="mb-0 text-xs" style={{marginBottom:'0'}}>My Profile</h6>
                                          <p class="mb-0 text-xs" style={{marginBottom:'0'}}>View personal profile details.</p>
                                       </div>
                                    </div>
                                 </a>
                                 <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'100%', display:'inline-block'}}>
                                <a className="iq-bg-danger iq-sign-btn" href="/generateevisitingcard" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Generate eVisitingCard<i className="ri-login-box-line ml-2"></i></a>    
				<a className="iq-bg-danger iq-sign-btn" href="#" role="button" onClick={handleLogout} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i className="ri-login-box-line ml-2"></i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                      )}
                     </li>
                        </ul>
                    </div>
                </div>
                <div style={{ display: 'flex',  justifyContent:'space-around'  }} >  
                    {this.state.data1.data.map(item => (
                        <div  className="mb-1">
                            <div className="col-md-4" key={item.id}>
                                <a href={item.attributes.Link}><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-sm'>{item.attributes.Title}</button></a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bg-silver1 pt-32'/>  

            <div className='bg-silver1'>
                <ul className="navbar-list" style={{display:'flex', flexWrap:'wrap' }}>
                {this.state.udata.map(item => (
                    <li key={item._id} style={{flex:'0 0 33.33%', padding:'10px' }}>
                    <div className="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                        <div className="iq-card-body p-0 " style={{padding:0}}>
                        <div style={{display:'flex'}}>
                            <div className="bg-primary p-3">
                            <img style={{marginTop:5, marginRight:5,cursor:'pointer', borderWidth:2, borderColor:'#0f90c0'}} src={`${BASE_URL}${item.picture?.url}`} alt={item.picture?.alternativeText} className="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white"/>
                            </div>
                            <div className="bg-primary p-3">
                            <h5 className="mb-0 text-xs line-height">{item.username} </h5>
                            <span className="text-xs">{item.email}</span>
                            <p className="text-xs">{item.empcode}</p>
                            <button className="iq-bg-danger iq-sign-btn text-white" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', display:'inline-block', background:'#0f90c0'}} onClick={() => this.handleApprove(item.empcode)}>Approve<i className="ri-login-box-line ml-2"></i></button>
                            </div> 
                        </div>
                        </div>
                    </div>
                    </li>
                    
                ))}
                </ul>
                {/*<p>{updatedProfilesCount} user profiles updated</p>
                <ul className="navbar-list">
                {this.state.ucount.map(item => (
                    // Render user profile items here
                    <li></li>
                ))}
                </ul>*/}
                <section>
                    <div className="footer">
                        <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 pr-3 text-xs text-darkblue'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
                    </div>
                </section>
            </div>
        </div>
    );
  }
}
export default ApprovalNotifications;
